import { render, staticRenderFns } from "./FullscreenControl.vue?vue&type=template&id=72722468&"
import script from "./FullscreenControl.vue?vue&type=script&lang=js&"
export * from "./FullscreenControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports